export default {
    is_loading: false,
    computed: {
        isLoading: function () {
            return this.is_loading;
        }.bind(this),
    },
    methods: {
        ajax: function (url, data, success) {
            this.is_loading = true;
            app.nprogress.start();
            axios.post(url, data)
                .then(function (response) {
                    if (typeof response.data.success !== 'undefined') {
                        if (typeof success !== 'undefined') {
                            success.call(this, response.data);
                        }
                    }
                }.bind(this))
                .catch(function (response) {
                    app.log.error(response.message, response);
                })
                .finally(function () {
                    this.is_loading = true;
                    app.nprogress.done();
                }.bind(this));
        },
    }
}
